import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';

export const AdditionalResourcesBlock = ({ data, t, country_code }) => {
  const langKey = getCurrentLangKey();

  return (
    <div className="block-xs additional-resources">
      <div className="container">
        <h3>{t.home_additional_resources}</h3>
        <div className="row margin-top">
          <ul>
            {
              data.additional_resources.map((resource, index) => {
                const localized_resource = resource.localizations.find(item => item.locale === langKey) || resource;
                return (
                  <div key={resource.id} className="col-md-4">
                    <li>
                      {localized_resource.external_link ? (
                        <a href={localized_resource.link} title={localized_resource.title} className={(index === 0) ? 'bold-link' : ''}>
                          {localized_resource.title}
                        </a>
                      ) : (
                        <Link to={`/${country_code}/${localized_resource.link}`} language={langKey} title={localized_resource.title} className={(index === 0) ? 'bold-link' : ''}>{localized_resource.title}</Link>
                      )}
                    </li>
                  </div>
                )
              })
            }
          </ul>
        </div>
      </div>
    </div>
  )
}
